import React from 'react';
import { nl2br } from './strings';
import { i18n, TFunction, ThirdPartyModule } from 'i18next';

/**
 * i18next middleware for changing the html tag's lang attribute
 */
export const changeHtmlLanguage: ThirdPartyModule = {
    type: '3rdParty',
    init: i18n => {
        i18n.on('languageChanged', l => document.documentElement.lang = l);
    },
};

/**
 * Resets the language for re-discovery
 */
export const resetLanguage = (i18n: i18n) => {
    localStorage.removeItem('i18nextLng');
    i18n.changeLanguage(null);
};

/**
 * Returns a new translator function which will replace \n in the translated value with <br/> tags
 */
export const multilineTranslate = (t: TFunction) =>
    (...args: Parameters<TFunction>): React.ReactNode => nl2br((t.apply(t, args) as string).replace(/\\n/g, '\n'));
